import { QueryCompanies } from '../models/query-companies';
import { Action } from '@ngrx/store';
import { ActionTypes } from '../../../core/models/actionTypes';

export const QueryCompaniesAction = (queryCompanies: QueryCompanies) => {
  return <Action>{ type: ActionTypes.QueryCompanies, payload: queryCompanies };
};
